export default "__VITE_ASSET__e9367323__"